import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, SelectInput, TextInput } from '@demandlocal/components'
import { motion } from 'framer-motion'

export default function OnboardingStepOne(): JSX.Element {
  const { control } = useFormContext()

  const jobTitleOptions = [
    { value: 'Owner', label: 'Owner' },
    { value: 'Manager', label: 'Manager' },
    { value: 'General Manager', label: 'General Manager' },
    { value: 'Sales Executive', label: 'Sales Executive' },
    { value: 'President', label: 'President' },
    { value: 'Marketing Executive', label: 'Marketing Executive' },
  ]

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-800">Tell us more about yourself!</h2>
        <p className="mt-2 text-md text-gray-600">
          Please provide your first and last name.
        </p>
      </div>

      {/* Form fields for first name and last name */}
      <div className="grid grid-cols-2 gap-6 mb-10">
        <div>
          <TextInput
            inverted
            name="first_name"
            label="First Name"
            placeholder="First name"
            control={control}
            rules={{ required: 'First name is required' }}
          />
        </div>
        <div>
          <TextInput
            inverted
            name="last_name"
            label="Last Name"
            placeholder="Last name"
            control={control}
            rules={{ required: 'Last name is required' }}
          />
        </div>
      </div>

      {/* Job title selection field */}
      <div className="mb-10">
        <SelectInput
          name="job_title"
          label="Job Title"
          control={control}
          options={jobTitleOptions}
          placeholder="Select your job title"
        />
      </div>

      {/* Navigation buttons */}
      <div className="flex justify-end">
        <Button type="submit" animate={false}>
          Next: Add your agency
        </Button>
      </div>
    </div>
  )
}
